class ImageViewer {
	constructor(ID) {
		this.element = document.getElementById(ID);
		if (!this.element) return;

		this.asset = this.element.getAttribute('data-asset');

		this.loadScript()
			.then(s7viewers => this.init(s7viewers))
			.then(imageCount => this.amendLayout(imageCount))
			.catch(() => {
				if (console) console.error('Scene7 MixedMediaViewer failed to load.'); // eslint-disable-line no-console
			});
	}

	loadScript() {
		return new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.src = '//odeu.scene7.com/s7viewers/html5/js/MixedMediaViewer.js';

			script.onload = () => resolve(window.s7viewers);
			script.onerror = reject;

			document.body.appendChild(script);
		});
	}

	init(s7viewers) {
		const { asset } = this;

		return new Promise(resolve => {
			const mixedMediaViewer = new s7viewers.MixedMediaViewer({
				containerId: 's7viewer',
				params: {
					asset,
					serverurl: '//static.viking.de/is/image',
					contenturl: '//s7d1.scene7.com/skins/',
					videoserverurl: '//odeu.scene7.com/is/content/',
				},
			});

			mixedMediaViewer.setHandlers({
				initComplete() {
					return resolve(mixedMediaViewer.numberOfItems);
				},
			});

			mixedMediaViewer.init();
		});
	}

	amendLayout(imageCount) {
		const parent = this.element.parentNode;

		parent.classList.add('image-viewer--is-loaded');

		if (imageCount === 1) {
			parent.classList.add('image-viewer--no-carousel');
		}
	}
}

export default ImageViewer;
